
function Cell (eventBus, {x, y, color}) {
    this.x        = x
    this.y        = y
    this.color    = color
    this.initialColor = color
    this.eventBus = eventBus
}


Cell.prototype.updateColor = function (color) {
    this.color = color
    this.eventBus.emit('cell color updated', this, color)
}


Cell.prototype.reset = function () {
    this.updateColor(this.initialColor)
}


export default Cell

